import { gql } from "@apollo/client";

export const PRODUCT_TABLE_QUERY = gql`
  query productTable($vendorId: Int!, $localizeInstalls: Boolean!) {
    productCatalogInstallsProducts(
      vendorIds: [$vendorId]
      localizeInstalls: $localizeInstalls
    ) {
      companyCount
      productName
      productId
    }
  }
`;
